// 引入第三方库js-cookie
import Cookies from 'js-cookie'

// 读取token值
export function getToken(TokenKey){
    return Cookies.get(TokenKey)
}

// 保存token值
export function setToken(TokenKey,token){
    return Cookies.set(TokenKey,token)
}

// 移除token值
export function removeToken(TokenKey){
    return Cookies.remove(TokenKey)
}


